import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaExchangeAlt, FaUser } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { LoggedUser } from "../../../atoms/userLogged";
import { goToPersonalData } from "../../../routes/coordinator";
import ModalChangePassword from "./modalChangePassword";
import ModalLogout from "./modalLogout";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";

const ProfileDrawer = ({ isOpen, setIsOpen }: any) => {
  const [open, setOpen] = useState(false);
  const colors = useRecoilState(customColors)[0];

  const onClose = () => {
    setIsOpen(false);
  };

  const navigate = useNavigate();

  const user = useRecoilState(LoggedUser)[0];

  return (
    <>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay backdropFilter="blur(10px)" />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            Olá,{" "}
            {user.nome
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})/g, (letra) =>
                letra.toUpperCase()
              )}{" "}
          </DrawerHeader>
          <DrawerBody p={6} justifyContent={"space-between"}>
            <Flex flexDirection={"column"}>
              <Button
                style={{ color: "white" }}
                leftIcon={<FaUser />}
                height="30px"
                onClick={() => {
                  goToPersonalData(navigate);
                  setIsOpen(false);
                }}
                width="200px"
                backgroundColor={colors.BLUEMONEDDBUTTONS} // colors.BLUEMONEDD cor original
                my={2}
              >
                Meus Dados
              </Button>
              {/* <Button
                style={{ color: "white" }}
                leftIcon={<FaPercentage />}
                height="30px"
                onClick={() => {
                  goToTarifasCliente(navigate);
                  setIsOpen(false);
                }}
                width="200px"
                backgroundColor={BLUECARD}
                my={2}
              >
                Meu Plano
              </Button> */}
              {/* <Button
                style={{ color: "white" }}
                leftIcon={<FaExchangeAlt />}
                height="30px"
                onClick={() => {
                  setOpenChangePassword(true);
                }}
                width="200px"
                backgroundColor={colors.BLUEMONEDDBUTTONS} // colors.BLUEMONEDD cor original
                my={2}
              >
                Alterar Senha
              </Button> */}
              <Button
                style={{ color: "white" }}
                background={colors.REDMONEDD}
                onClick={() => setOpen(true)}
                rightIcon={<FiLogOut />}
                height="30px"
                width="100px"
                my={2}
              >
                Sair
              </Button>
            </Flex>
          </DrawerBody>
          <DrawerFooter></DrawerFooter>
          <ModalLogout isOpen={open} setIsOpen={setOpen} />
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default ProfileDrawer;
